<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/iotdm/card/page" getKey="rows"
      :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('iccid')">
            <el-input v-model="yt.conditions.iccid"></el-input>
          </el-form-item>
          <el-form-item :label="$t('yunyingshang')">
            <yi_dictionary_select :type="'IOTDM_CARD_CARRIERS'" :ids.sync="yt.conditions.carrier">
            </yi_dictionary_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary"
              plain="plain">
              {{$t('sousuo')}}
            </el-button>
            <el-button @click="yt.clear({orderBy:'createTime desc'})">{{$t('chongzhi')}}
            </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'w1')" type="primary">
          {{$t('xinzeng')}}
        </el-button>
        <el-button size="mini" @click="show = !show" plain>
          {{$t('daoru')}}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <!-- <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')"  @click="yt.exportExcel()"></el-button>
            </el-button> -->
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"  @click="yt.showColumnsDialog()"></el-button>

      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row)">{{$t('bianji')}}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
      :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('ICCID')" class="noborder" required>
            <el-input v-model="yt.editObj.iccid">
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('yunyingshang')" required="required">
            <yi_dictionary_select :type="'IOTDM_CARD_CARRIERS'" :ids.sync="yt.editObj.carrier">
            </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('wuliankaliuliang')">
            <el-input v-model="yt.editObj.flow"></el-input>
          </el-form-item>
          <el-form-item :label="$t('dangqianzhuangtai')">
            <yi_dictionary_select :type="'IOTDM_CARD_STATUS'" :ids.sync="yt.editObj.status">
            </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('jihuoshijian')">
            <yi_time_input format="yyyy-MM-dd" type="date" :time.sync="yt.editObj.activationDate">
            </yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('tingyongshijian')">
            <yi_time_input format="yyyy-MM-dd" type="date" :time.sync="yt.editObj.deactivationDate">
            </yi_time_input>
          </el-form-item>

        </el-form>
        <template slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
          <el-button size="mini" @click="yt.req('POST','/web/iotdm/card/create')" type="primary">
            {{$t('baocun')}}
          </el-button>
        </template>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('ICCID')" class="noborder" required>
            <el-input disabled v-model="yt.editObj.iccid">
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('yunyingshang')" required="required">
            <yi_dictionary_select disabled :type="'IOTDM_CARD_CARRIERS'" :ids.sync="yt.editObj.carrier">
            </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('wuliankaliuliang')">
            <el-input v-model="yt.editObj.flow"></el-input>
          </el-form-item>
          <el-form-item :label="$t('dangqianzhuangtai')">
            <yi_dictionary_select :type="'IOTDM_CARD_STATUS'" :ids.sync="yt.editObj.status">
            </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('jihuoshijian')">
            <yi_time_input format="yyyy-MM-dd" type="date" :time.sync="yt.editObj.activationDate">
            </yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('tingyongshijian')">
            <yi_time_input format="yyyy-MM-dd" type="date" :time.sync="yt.editObj.deactivationDate">
            </yi_time_input>
          </el-form-item>

        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
          <el-button size="mini" @click="yt.req('POST','/web/iotdm/card/update')" type="primary">
            {{$t('baocun')}}
          </el-button>

        </span>
      </template>
      <!-- 导入 -->
      <!--<template v-if="yt.editObj.action == 'daoru'">
        <div class="dialog-scroller">
          <list></list>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.req('POST','/web/basic/material/update')" type="primary">
            {{$t('queren')}}
          </el-button>
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
        </span>
      </template>-->
    </el-dialog>

    <import-excel :show.sync="show" />
  </div>
</template>
<script type="text/javascript">
	import importExcel from '@@/pages/admin/iotdm/card/import_excel'

	export default {
		name: 'admin_iotdm_card_list',
		components: {
			importExcel
		},
		data() {
			return {
				list: [],
				show: false,
				columns: [{
					label: 'iccid',
					prop: 'iccid'
				}, {
					label: 'yunyingshang',
					prop: 'carrier',
					type: 'dictionary',
					key: 'IOTDM_CARD_CARRIERS',
					width: 150
				}, {
					label: 'wuliankaliuliang',
					prop: 'flow'
				}, {
					label: 'dangqianzhuangtai',
					prop: 'status',
					type: 'dictionary',
					key: 'IOTDM_CARD_STATUS',
					width: 150
				},
				{
					label: 'jihuoshijian',
					prop: 'activationDate',
					type: 'time',
					format: 'YYYY-MM-DD'
				}, {
					label: 'tingyongshijian',
					prop: 'deactivationDate',
					type: 'time',
					format: 'YYYY-MM-DD'
				}, {
					label: 'dangyueshengyuliuliang',
					prop: 'unusedFlow'
				}, {
					label: 'caozuo',
					type: 'slot',
					width: 180,
					fixed: 'right'
				}]
			};
		},
		created() {
			setTimeout(() => {
				this.yt.conditions = {
					orderBy:'createTime desc',
				}
        this.yt.SELECT_URL = "/web/iotdm/card/getCardByIds"
        this.yt.SELECT_RESULT_KEY = "data"
        this.yt.SELECT_ID = "id"
        this.yt.SELECT_TITLE = "iccid"
				this.yt.get(1);
				this.utils.event_hub.$on('IOTDM_CARD_REFRESH', () => {
					this.yt.get();
				})
			}, 300)
		},

		methods: {}
	};
</script>
